import { render } from "./MaterialCheckbox.vue?vue&type=template&id=386df353"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__